import React from 'react';
import { useQuery } from 'react-fetching-library';
import { Link } from 'react-router-dom';
import { Stack, Card, CardContent, Typography } from '@mui/material';
import Page from '../../components/Page';
import { getSurveysTemplatesAction } from '../../services/request';


export default function Surveys () {
  const { loading, payload, error } = useQuery(getSurveysTemplatesAction());
  const [surveys, setSurveys] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setSurveys(payload);
    }
  }, [loading]);

  return (
    <Page title="Ankiety">
      <Stack spacing={2} ml={1} mr={16}>
        {surveys.map(survey => <Link key={survey.id} to={`${survey.id}`}>
          <Card sx={{ ':hover': { color: '#00AB55', textDecoration: 'underline' }, cursor: 'pointer' }}>
            <CardContent>
              <Typography>
                {`${survey.identifier.replaceAll('_', ' ').toUpperCase()} (wersja ${survey.version})`}
              </Typography>
            </CardContent>
          </Card>
        </Link>)}
      </Stack>
    </Page>
  );
};

